import React, { Component } from "react";
import { Switch, Redirect, Route } from "react-router-dom";

import Apply from "./screens/apply";
import Orders  from "./screens/orders"
import OrderDetail from "./screens/orders/order-detail"
import AptitudeTestResultLogin from './screens/aptitude-test/result/login'
import AptitudeTestResultDashboard from './screens/aptitude-test/result/dashboard'
import Layout from './layout'

export default class App extends Component {
    render() {

        return (
          <>
           {/*<Layout>*/}
                 <Switch>
    <Route component={AptitudeTestResultLogin} path={`/aptitude-test-result/login`} />
    <Route component={AptitudeTestResultDashboard} path={`/aptitude-test-result/dashboard`} />
                    <Route component={Apply} path={`/apply/:uid`} />
                       <Route component={OrderDetail} path={`/orders/:uid`} />
                        <Route component={Orders} path={`/orders`} />
 <Redirect to={`/aptitude-test-result/login`}/>


                </Switch>
           {/*</Layout>*/}
           <a href="/web/aptitude-test-result/dashboard"></a>
           </>
        );
    }
}
